import type { FC, ReactNode } from "react";
import { Fragment } from "react";
import Date, { DateProps } from "../atom/date";

type Props = DateProps & {
  label?: ReactNode;
  placeholder?: ReactNode;
};

export const AssigneeDate: FC<Props> = (props) => {
  const { value, label = "Ngày thực hiện", placeholder } = props;

  if (!value) {
    return <Fragment>{placeholder}</Fragment>;
  }

  return (
    <Fragment>
      {label}: <Date value={value} />
    </Fragment>
  );
};
